/* hs-eslint ignored failing-rules */
/* eslint-disable react-hooks/exhaustive-deps */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["color", "defaultAlpha", "defaultColor", "onColorChange", "onPickerModeChange", "onOpenChange", "renderColorPicker"];
import PropTypes from 'prop-types';
import { useState, useCallback } from 'react';
import debounce from 'react-utils/debounce';
import { callIfPossible } from 'UIComponents/core/Functions';
import UITextToolbarColorDropdown from '../editor/UITextToolbarColorDropdown';
import { ColorPickerModes } from '../../constants/popover';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  color: PropTypes.object,
  defaultAlpha: PropTypes.number,
  defaultColor: PropTypes.string,
  onColorChange: PropTypes.func.isRequired,
  onPickerModeChange: PropTypes.func,
  onOpenChange: PropTypes.func,
  renderColorPicker: PropTypes.func.isRequired
};
function ColorPickerToolbarButton(props) {
  const {
      color: _color,
      defaultAlpha,
      defaultColor,
      onColorChange,
      onPickerModeChange,
      onOpenChange,
      renderColorPicker
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const color = _color || {
    color: defaultColor,
    alpha: defaultAlpha
  };
  const [tempColor, setTempColor] = useState(null);
  const [pickerMode, setPickerMode] = useState(ColorPickerModes.SIMPLE);
  const colorChangeCallback = useCallback(payload => {
    setTempColor(null);
    onColorChange(payload);
  }, [onColorChange]);
  const handleDebouncedColorChange = useCallback(debounce(colorChangeCallback, 400), [colorChangeCallback]);
  const handleColorChange = evt => {
    const {
      value: updatedColor
    } = evt.currentTarget;
    const payload = Object.assign({}, updatedColor, {
      mode: pickerMode
    });
    if (pickerMode === ColorPickerModes.SIMPLE) {
      setTempColor(null);
      onColorChange(payload);
    } else {
      setTempColor(updatedColor);
      handleDebouncedColorChange(payload);
    }
  };
  const handlePickerModeChange = evt => {
    const {
      value: updatedPickerMode
    } = evt.target;
    setPickerMode(updatedPickerMode);
    callIfPossible(onPickerModeChange, updatedPickerMode);
  };
  const handleOpenChange = evt => {
    const {
      value: isOpen
    } = evt.target;
    if (!isOpen) {
      setPickerMode(ColorPickerModes.SIMPLE);
    }
    callIfPossible(onOpenChange, isOpen);
  };
  const handleResetClick = () => {
    setTempColor(null);
    onColorChange({
      color: null,
      alpha: null,
      mode: pickerMode
    });
  };
  return /*#__PURE__*/_jsx(UITextToolbarColorDropdown, Object.assign({}, rest, {
    color: tempColor || color,
    onColorChange: handleColorChange,
    onOpenChange: handleOpenChange,
    onPickerModeChange: handlePickerModeChange,
    onResetClick: handleResetClick,
    DropdownContent: renderColorPicker,
    menuWidth: 300,
    autoPlacement: "horiz",
    pinToConstraint: ['left', 'right']
  }));
}
ColorPickerToolbarButton.propTypes = propTypes;
ColorPickerToolbarButton.displayName = 'ColorPickerToolbarButton';
export default ColorPickerToolbarButton;